import Default from '../../layouts/default';
import Cadastro from '../../layouts/cadastro';

const indexRoutes = [
  { path: '/concluir-cadastro', component: Cadastro },
  { path: '/sucesso', component: Cadastro },
  { path: '/editar-perfil-:id', component: Default },
  { path: '/quem-e-quem', component: Default },
  { path: '/biblioteca', component: Default },
  { path: '/nova-reuniao', component: Default },
  { path: '/editar-reuniao', component: Default },
  { path: '/', component: Default },
  { path: '', component: Default },

];

export default indexRoutes;
